import { postUpdateLottery } from '../api/postUpdateLottery';

const setPostUpdateLottery = (params) => {
    return async (dispatch, getState) => {
        try {
            await postUpdateLottery(params);
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setPostUpdateLottery
}